/* hc-stories — stories vidéo produit : cercles d'aperçu + modale de lecture (remplace Tolstoy) */
(function () {
  'use strict';

  if (window.HcStories) return;

  var MOBILE_QUERY = '(max-width: 749px)';
  var SWIPE_MIN_PX = 50;

  function noop() {}

  /* Source mp4 la plus haute ≤ 1080 px ; à défaut la plus haute disponible */
  function pickSource(sources) {
    if (!sources || !sources.length) return null;
    var best = null;
    var fallback = null;
    for (var i = 0; i < sources.length; i++) {
      var s = sources[i];
      if (!s || !s.url) continue;
      if (s.type && s.type !== 'video/mp4') continue;
      if (/\.m3u8(\?|$)/i.test(s.url)) continue;
      var h = Number(s.height) || 0;
      if (!fallback || h > (Number(fallback.height) || 0)) fallback = s;
      if (h <= 1080 && (!best || h > (Number(best.height) || 0))) best = s;
    }
    return best || fallback;
  }

  function svg(paths, fill) {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"' + (fill ? ' style="fill:currentColor;stroke:none"' : '') + '>' + paths + '</svg>';
  }

  var ICONS = {
    close: svg('<path d="M6 6l12 12M18 6L6 18"/>'),
    prev: svg('<path d="M15 5l-7 7 7 7"/>'),
    next: svg('<path d="M9 5l7 7-7 7"/>'),
    soundOn: svg('<path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16 9.5a3.5 3.5 0 0 1 0 5"/><path d="M18.5 7a7 7 0 0 1 0 10"/>'),
    soundOff: svg('<path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16 9l5 6M21 9l-5 6"/>'),
    pause: svg('<rect x="6" y="4" width="4" height="16" rx="1"/><rect x="14" y="4" width="4" height="16" rx="1"/>', true)
  };

  var FOCUSABLE = 'button:not([hidden]), [href], [tabindex]:not([tabindex="-1"])';

  /* ---------- Modale (une seule instance par page) ---------- */

  function HcStoriesModal() {
    this.stories = [];
    this.index = 0;
    this.opener = null;
    this.isOpen = false;
    this.muted = false;
    this.raf = 0;
    this.touch = null;
    this.build();
  }

  HcStoriesModal.prototype.build = function () {
    var root = document.createElement('div');
    root.className = 'hc-stories-modal';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.hidden = true;
    root.innerHTML =
      '<div class="hc-stories-modal__player">' +
        '<video class="hc-stories-modal__video" playsinline preload="auto" disablepictureinpicture disableremoteplayback></video>' +
        '<div class="hc-stories-modal__loader"></div>' +
        '<div class="hc-stories-modal__paused">' + ICONS.pause + '</div>' +
        '<div class="hc-stories-modal__top">' +
          '<div class="hc-stories-modal__progress" aria-hidden="true"></div>' +
          '<div class="hc-stories-modal__bar">' +
            '<span class="hc-stories-modal__title"></span>' +
            '<button type="button" class="hc-stories-modal__btn hc-stories-modal__mute" aria-label="Couper le son" aria-pressed="false">' +
              '<span class="hc-stories-modal__icon-on">' + ICONS.soundOn + '</span>' +
              '<span class="hc-stories-modal__icon-off">' + ICONS.soundOff + '</span>' +
            '</button>' +
            '<button type="button" class="hc-stories-modal__btn hc-stories-modal__close" aria-label="Fermer">' + ICONS.close + '</button>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="hc-stories-modal__btn hc-stories-modal__nav hc-stories-modal__nav--prev" aria-label="Story précédente">' + ICONS.prev + '</button>' +
      '<button type="button" class="hc-stories-modal__btn hc-stories-modal__nav hc-stories-modal__nav--next" aria-label="Story suivante">' + ICONS.next + '</button>';

    this.root = root;
    this.player = root.querySelector('.hc-stories-modal__player');
    this.video = root.querySelector('.hc-stories-modal__video');
    this.progress = root.querySelector('.hc-stories-modal__progress');
    this.titleEl = root.querySelector('.hc-stories-modal__title');
    this.muteBtn = root.querySelector('.hc-stories-modal__mute');
    this.closeBtn = root.querySelector('.hc-stories-modal__close');
    this.prevBtn = root.querySelector('.hc-stories-modal__nav--prev');
    this.nextBtn = root.querySelector('.hc-stories-modal__nav--next');

    var self = this;

    /* Clic sur le fond (hors lecteur) : fermeture */
    root.addEventListener('click', function (e) {
      if (e.target === root) self.close();
    });
    this.closeBtn.addEventListener('click', function () { self.close(); });
    this.prevBtn.addEventListener('click', function () { self.prev(); });
    this.nextBtn.addEventListener('click', function () { self.next(); });
    this.muteBtn.addEventListener('click', function () { self.setMuted(!self.muted); });

    /* Tap sur la vidéo : pause / lecture */
    this.video.addEventListener('click', function () { self.togglePlay(); });

    this.video.addEventListener('ended', function () { self.onEnded(); });
    this.video.addEventListener('play', function () { root.classList.remove('is-paused'); });
    this.video.addEventListener('pause', function () {
      if (!self.video.ended) root.classList.add('is-paused');
    });
    this.video.addEventListener('waiting', function () { root.classList.add('is-buffering'); });
    this.video.addEventListener('loadstart', function () { root.classList.add('is-buffering'); });
    this.video.addEventListener('playing', function () { root.classList.remove('is-buffering'); });
    this.video.addEventListener('canplay', function () { root.classList.remove('is-buffering'); });
    this.video.addEventListener('error', function () {
      /* Source illisible : on passe à la suivante plutôt que de bloquer */
      root.classList.remove('is-buffering');
      if (self.isOpen && self.video.error) self.onEnded();
    });

    /* Balayage horizontal (mobile) */
    this.player.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0];
      self.touch = { x: t.clientX, y: t.clientY };
    }, { passive: true });
    this.player.addEventListener('touchend', function (e) {
      if (!self.touch) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - self.touch.x;
      var dy = t.clientY - self.touch.y;
      self.touch = null;
      if (Math.abs(dx) >= SWIPE_MIN_PX && Math.abs(dx) > Math.abs(dy)) {
        e.preventDefault();
        if (dx < 0) self.next(); else self.prev();
      }
    });

    this.onKeydown = this.onKeydown.bind(this);
    this.tick = this.tick.bind(this);

    document.body.appendChild(root);
  };

  HcStoriesModal.prototype.open = function (stories, index, opener) {
    if (!stories || !stories.length) return;
    this.stories = stories;
    this.opener = opener || document.activeElement;
    this.buildProgress();
    if (!this.isOpen) {
      this.isOpen = true;
      this.root.hidden = false;
      document.body.classList.add('overflow-hidden');
      document.addEventListener('keydown', this.onKeydown);
    }
    /* La modale s'ouvre sur un geste utilisateur : lecture avec le son */
    this.setMuted(false);
    this.show(index);
    this.closeBtn.focus({ preventScroll: true });
    this.raf = requestAnimationFrame(this.tick);
  };

  HcStoriesModal.prototype.close = function () {
    if (!this.isOpen) return;
    this.isOpen = false;
    cancelAnimationFrame(this.raf);
    document.removeEventListener('keydown', this.onKeydown);
    this.video.pause();
    this.video.removeAttribute('src');
    this.video.removeAttribute('poster');
    this.video.load();
    this.root.hidden = true;
    this.root.classList.remove('is-paused', 'is-buffering');
    document.body.classList.remove('overflow-hidden');
    var opener = this.opener;
    this.opener = null;
    if (opener && typeof opener.focus === 'function' && document.contains(opener)) {
      opener.focus({ preventScroll: true });
    }
  };

  HcStoriesModal.prototype.buildProgress = function () {
    var html = '';
    for (var i = 0; i < this.stories.length; i++) {
      html += '<span class="hc-stories-modal__seg"><span class="hc-stories-modal__seg-fill"></span></span>';
    }
    this.progress.innerHTML = html;
    this.segs = Array.prototype.slice.call(this.progress.children);
  };

  HcStoriesModal.prototype.show = function (index) {
    var story = this.stories[index];
    if (!story) return this.close();
    this.index = index;

    var title = story.title || '';
    this.titleEl.textContent = title;
    this.root.setAttribute('aria-label', title || 'Story');

    /* Segments : passés remplis, courant à zéro, suivants vides */
    for (var i = 0; i < this.segs.length; i++) {
      this.segs[i].classList.toggle('is-done', i < index);
      this.segs[i].firstChild.style.transform = 'scaleX(0)';
    }

    this.prevBtn.hidden = index === 0;
    this.nextBtn.hidden = index >= this.stories.length - 1;

    var source = pickSource(story.sources);
    var video = this.video;
    this.root.classList.remove('is-paused');
    video.pause();
    if (story.poster) video.setAttribute('poster', story.poster); else video.removeAttribute('poster');
    if (!source) {
      video.removeAttribute('src');
      video.load();
      this.root.classList.remove('is-buffering');
      return;
    }
    video.muted = this.muted;
    video.setAttribute('src', source.url);
    video.load();
    this.play();
  };

  HcStoriesModal.prototype.play = function () {
    var self = this;
    var p = this.video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {
        /* Lecture avec son refusée : on retente en muet */
        if (!self.isOpen) return;
        if (!self.muted) {
          self.setMuted(true);
          var p2 = self.video.play();
          if (p2 && typeof p2.catch === 'function') p2.catch(noop);
        }
      });
    }
  };

  HcStoriesModal.prototype.togglePlay = function () {
    if (this.video.paused) this.play(); else this.video.pause();
  };

  HcStoriesModal.prototype.setMuted = function (muted) {
    this.muted = !!muted;
    this.video.muted = this.muted;
    this.root.classList.toggle('is-muted', this.muted);
    this.muteBtn.setAttribute('aria-pressed', this.muted ? 'true' : 'false');
    this.muteBtn.setAttribute('aria-label', this.muted ? 'Activer le son' : 'Couper le son');
  };

  HcStoriesModal.prototype.next = function () {
    if (this.index < this.stories.length - 1) this.show(this.index + 1);
  };

  HcStoriesModal.prototype.prev = function () {
    if (this.index > 0) this.show(this.index - 1);
  };

  /* Fin de vidéo : story suivante, ou fermeture après la dernière */
  HcStoriesModal.prototype.onEnded = function () {
    if (this.index < this.stories.length - 1) this.show(this.index + 1); else this.close();
  };

  /* Progression du segment courant, rafraîchie à chaque frame */
  HcStoriesModal.prototype.tick = function () {
    if (!this.isOpen) return;
    var v = this.video;
    var seg = this.segs[this.index];
    if (seg && v.duration > 0) {
      var ratio = Math.min(1, v.currentTime / v.duration);
      seg.firstChild.style.transform = 'scaleX(' + ratio.toFixed(4) + ')';
    }
    this.raf = requestAnimationFrame(this.tick);
  };

  HcStoriesModal.prototype.onKeydown = function (e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      this.close();
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      this.next();
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      this.prev();
    } else if (e.key === ' ' && e.target === this.root) {
      e.preventDefault();
      this.togglePlay();
    } else if (e.key === 'Tab') {
      /* Focus contenu dans la modale */
      var items = Array.prototype.filter.call(this.root.querySelectorAll(FOCUSABLE), function (el) {
        return !el.hidden && el.offsetParent !== null;
      });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || !this.root.contains(document.activeElement))) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (document.activeElement === last || !this.root.contains(document.activeElement))) {
        e.preventDefault();
        first.focus();
      }
    }
  };

  var modalInstance = null;
  function getModal() {
    if (!modalInstance) modalInstance = new HcStoriesModal();
    return modalInstance;
  }

  /* ---------- Élément <hc-stories> : rangée de cercles ---------- */

  function HcStoriesElement() {
    return Reflect.construct(HTMLElement, [], HcStoriesElement);
  }
  HcStoriesElement.prototype = Object.create(HTMLElement.prototype);
  HcStoriesElement.prototype.constructor = HcStoriesElement;
  Object.setPrototypeOf(HcStoriesElement, HTMLElement);

  HcStoriesElement.prototype.connectedCallback = function () {
    if (this.hcBound) return;
    this.hcBound = true;
    var self = this;

    this.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-hc-story]');
      if (!tile || !self.contains(tile)) return;
      e.preventDefault();
      var stories = self.getStories();
      var index = parseInt(tile.getAttribute('data-hc-story'), 10) || 0;
      getModal().open(stories, index, tile);
    });

    this.setupThumbs();
  };

  HcStoriesElement.prototype.disconnectedCallback = function () {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  };

  HcStoriesElement.prototype.getStories = function () {
    if (this.stories) return this.stories;
    var script = this.querySelector('script[data-hc-stories-data]');
    var data = [];
    try {
      data = JSON.parse(script ? script.textContent : '[]');
    } catch (err) {
      data = [];
    }
    this.stories = Array.isArray(data) ? data : [];
    return this.stories;
  };

  /* Aperçus : lecture relancée si l'autoplay a été ignoré, pause hors écran */
  HcStoriesElement.prototype.setupThumbs = function () {
    var thumbs = this.querySelectorAll('video.hc-stories__thumb');
    if (!thumbs.length) return;
    var tryPlay = function (v) {
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(noop);
    };
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) tryPlay(entry.target); else entry.target.pause();
        });
      }, { rootMargin: '100px' });
      var self = this;
      thumbs.forEach(function (v) { self.observer.observe(v); });
    } else {
      thumbs.forEach(tryPlay);
    }
  };

  if (window.customElements && !customElements.get('hc-stories')) {
    customElements.define('hc-stories', HcStoriesElement);
  }

  /* Éditeur de thème : le bloc sélectionné est amené à l'écran */
  document.addEventListener('shopify:block:select', function (e) {
    var tile = e.target && e.target.closest ? e.target.closest('.hc-stories__tile') : null;
    if (tile) tile.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
  });

  window.HcStories = {
    version: '1.0.0',
    pickSource: pickSource,
    open: function (stories, index, opener) { getModal().open(stories, index || 0, opener); },
    close: function () { if (modalInstance) modalInstance.close(); },
    isMobile: function () { return window.matchMedia(MOBILE_QUERY).matches; }
  };
})();
